import { render, staticRenderFns } from "./SelectProductTypeList.vue?vue&type=template&id=3f377118&scoped=true&"
import script from "./SelectProductTypeList.vue?vue&type=script&lang=js&"
export * from "./SelectProductTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f377118",
  null
  
)

export default component.exports